import React from 'react';
import { invoiceNumberCorrelativo } from './invoiceNumberUtils';

import { Button, Modal } from 'react-bootstrap';

import { LuFileDown } from 'react-icons/lu';



const EMPRESA_PTB = 1;



const InvoiceDescargasModal = ({

  show,

  row,

  onClose,

  onDownloadPackingList,

  onDownloadInvoicePtc,

  onDownloadInvoicePtb,

  downloadingPl,

  downloadingPtc,

  downloadingPtb,

}) => {

  const esEmisorPtb = row?.empresa_emisor === EMPRESA_PTB;

  const busy = downloadingPl || downloadingPtc || downloadingPtb;



  return (

    <Modal show={show} onHide={onClose} centered>

      <Modal.Header closeButton>

        <Modal.Title>Descargar documentos</Modal.Title>

      </Modal.Header>

      <Modal.Body>

        <p className="text-muted small">

          {row?.tiene_invoice

            ? `Invoice ${invoiceNumberCorrelativo(row?.numero_invoice)} — Booking ${row?.nro_booking}`

            : `Booking ${row?.nro_booking} — sin invoice`}

        </p>

        <div className="d-flex flex-column gap-2">

          {!esEmisorPtb ? (

            <span

              className="d-block"

              title={!row?.tiene_invoice ? 'Se debe crear prefactura' : undefined}

              style={!row?.tiene_invoice ? { cursor: 'not-allowed' } : undefined}

            >

              <Button

                type="button"

                variant="outline-primary"

                className="d-flex align-items-center justify-content-center gap-2 w-100"

                disabled={!row?.tiene_invoice || !row?.id_invoice || busy}

                style={!row?.tiene_invoice ? { pointerEvents: 'none' } : undefined}

                onClick={() => row?.tiene_invoice && onDownloadInvoicePtc(row)}

              >

                <LuFileDown />

                {downloadingPtc ? 'Generando…' : 'Invoice PTC (PDF)'}

              </Button>

            </span>

          ) : null}

          <span

            className="d-block"

            title={!row?.tiene_invoice ? 'Se debe crear prefactura' : undefined}

            style={!row?.tiene_invoice ? { cursor: 'not-allowed' } : undefined}

          >

            <Button

              type="button"

              variant="outline-primary"

              className="d-flex align-items-center justify-content-center gap-2 w-100"

              disabled={!row?.tiene_invoice || !row?.id_invoice || busy}

              style={!row?.tiene_invoice ? { pointerEvents: 'none' } : undefined}

              onClick={() => row?.tiene_invoice && onDownloadInvoicePtb(row)}

            >

              <LuFileDown />

              {downloadingPtb ? 'Generando…' : 'Invoice PTB (PDF)'}

            </Button>

          </span>

          <Button

            type="button"

            variant="outline-primary"

            className="d-flex align-items-center justify-content-center gap-2"

            disabled={!row?.id_packing_list || busy}

            onClick={() => onDownloadPackingList(row)}

          >

            <LuFileDown />

            {downloadingPl ? 'Generando…' : 'Packing List (PDF)'}

          </Button>

        </div>

      </Modal.Body>

      <Modal.Footer>

        <Button variant="secondary" onClick={onClose}>

          Cerrar

        </Button>

      </Modal.Footer>

    </Modal>

  );

};



export default InvoiceDescargasModal;

